import { AssignmentLate } from '@mui/icons-material';

import { claimMap } from '@/router/claimMap';
import { basicRoles } from '@/router/consts';

import type { SidebarMenu } from '../../types';

const claimMenus: SidebarMenu[] = [
  {
    title: claimMap.index.title,
    path: claimMap.index.path,
    icon: <AssignmentLate />,
    roles: basicRoles,
    childrenMenus: [claimMap['order-cancel'], claimMap['return'], claimMap['exchange']],
  },
];

export default claimMenus;
